import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'
import Message from '../../config/message_v2.js';

export default {

  ValidateForm(form){
    if(!form.description){
      toast.warning(Message.ERROR.EMPTY.DESCRIPTION)
      return false
    } else if (!form.scheduledStart) {
      console.log(form.scheduledStart);
      toast.warning(Message.ERROR.EMPTY.SCHEDULE_START)
      return false
    } else if (!form.scheduledEnd) {
      toast.warning(Message.ERROR.EMPTY.SCHEDULE_END)
      return false
    } 
    return true
  }
  
}


// WEBPACK FOOTER //
// ./src/App/request/helper/form.js